import Tooltip from 'rc-tooltip';
import React from 'react';
import styles from './ThumbY.scss';

const ThumbY = (props) => {
	const { elementRef, dragTooltipRef, ...restProps } = props;
	const ret = (
		<div {...restProps} ref={elementRef}>
			{dragTooltipRef.current && (
				<Tooltip
					visible
					overlay={dragTooltipRef.current()}
					placement='left'
					overlayClassName={styles.tooltip}
				>
					<div style={{ height: '100%' }} />
				</Tooltip>
			)}
		</div>
	);
	return ret;
};

export default ThumbY;
